import { useState } from 'react';
import { LuChevronDown, LuChevronUp, LuChevronLeft, LuChevronRight, LuMenu } from 'react-icons/lu';
import classNames from 'classnames';

import styles from './SettingsButton.module.css';
import { Button } from '../ui/button';

export function SettingsButton({
    direction = 'bottom',
    className,
    children,
}: {
    direction?: 'top' | 'bottom' | 'left' | 'right';
    className?: string;
    children: React.ReactNode;
}) {
    let arrowIcon;
    switch (direction) {
        case 'top':
            arrowIcon = <LuChevronUp />;
            break;
        case 'left':
            arrowIcon = <LuChevronLeft />;
            break;
        case 'right':
            arrowIcon = <LuChevronRight />;
            break;
        default:
            arrowIcon = <LuChevronDown />;
    }

    const [isOpen, setIsOpen] = useState(false);

    const handleToggleSettings = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div
            className={classNames(styles.container, styles[`container-${direction}`], className)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <div>
                <Button
                    className={styles.settingsButton}
                    preset="secondary"
                    icon={!isOpen ? <LuMenu /> : arrowIcon}
                    onClick={handleToggleSettings}
                    onMouseEnter={() => setIsOpen(true)}
                />
            </div>
            <div className={classNames(styles.dropdown, isOpen ? styles.show : styles.hide)}>
                <div
                    className={classNames(
                        styles.settingsDropdown,
                        styles[`dropdown-${direction}`],
                        isOpen ? styles[`show-${direction}`] : styles[`hide-${direction}`]
                    )}
                >
                    {children}
                </div>
            </div>
        </div>
    );
}
